export const environment = {
  production: true,
  baseUrl: "https://childrenscodingclub.com",
  apiUrl: "https://childrenscodingclub.com/api",
  socketIOURL: "https://childrenscodingclub.com",
  socketIOOptionsPath: "/api/socket.io",
};
